// extracted by mini-css-extract-plugin
export default {"view":"Root_view__Gob9r","root":"Root_root__m2FCh"};